import React from 'react'
import { Container } from 'components/UIElements'
import CaregiversTable from './CaregiversTable'
import SadCloud from 'components/SadCloud'

const CaregiversList = (props) => {
    const content = <CaregiversTable {...props} />

    return (
        <Container>
            {content}
        </Container>
    )
}

export default CaregiversList
